import React from "react";

import { StreakStat } from "@data-types/sport-stats/SportStatsTypes";
import { Team } from "@gp/models";

export const renderStreak = (
	team: Team | undefined,
	label: string,
	icon: React.ReactNode,
	item: StreakStat,
	index: number,
	t: (key: string, options?: Record<string, any>) => string
) => (
	<div
		key={`${index}-${label.toLowerCase()}`}
		className="card--stats__row"
		data-at="at-renderStreak"
	>
		<div className="card--stats__col card--stats__col--left">
			{icon}
			<div className="card--stats__value">{label}</div>
		</div>
		<div className="card--stats__col card--stats__col--middle">
			<div className="card--stats__label">
				{t(`EVENT.STATISTICS.STREAK_STATS.${item.abrv}`, {
					margin: item.margin,
				})}
			</div>
		</div>
		<div className="card--stats__col card--stats__col--right">
			<div className="card--stats__value">{item.value}</div>
		</div>
	</div>
);
